import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'

import { DelmanGuard } from '@/features/delman/DelmanGuard'
import { DelmanShell } from '@/shared/layouts/DelmanShell'

export function DelmanAppLayout({ children }: { children?: ReactNode }) {
  return (
    <DelmanGuard>
      <DelmanShell>{children ?? <Outlet />}</DelmanShell>
    </DelmanGuard>
  )
}
